// extracted by mini-css-extract-plugin
export default {"actions":"styles_actions__x57N0","footer":"styles_footer__VZFX7","headerColContent":"styles_headerColContent__IOxZU"};